import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ShadowRealmIllustration({
  achievementId,
  variant = 'shadow',
  // Unlocks shadow variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4224" data-mp="10g67pdqxpsjo">
      
      <div className="relative w-full h-full bg-slate-950 overflow-hidden" data-id="element-4225" data-mp="vhuxv30n3i1g">
        {/* Background: Dark Aura */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4226" data-mp="1a6hfjbdqolvu">
          
          <circle cx="100" cy="100" r="80" fill="#4C1D95" opacity="0.3" filter="blur(20px)" data-id="element-4227" data-mp="15dfuelmxvq3t" />
          
          <circle cx="100" cy="100" r="50" fill="#000000" opacity="0.5" filter="blur(10px)" data-id="element-4228" data-mp="hntutx2nn8va" />
          

          {/* Shadow tendrils */}
          <path d="M100 100 Q40 40 20 80" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-4229" data-mp="3u57iye1n0eme" />
          
          <path d="M100 100 Q160 160 180 120" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-4230" data-mp="1z2esplucbtq" />
          
          <path d="M100 100 Q150 40 120 20" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-4231" data-mp="br84fsomeh5r" />
          
          <path d="M100 100 Q50 160 80 180" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-4232" data-mp="3b7ej5kmb8kt8" />
          
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-4233" data-mp="3k5gogcd2tzmb">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-4234" data-mp="3p5ux9wmi5dle">
            <DjaySpecimen look={{
            variant,
            accessory: 'shadowOrb'
          }} size="hero" emotion={isUnlocked ? 'surprised' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4235" data-mp="zgj6relmcjm0" />
            
          </div>
        </div>

        {/* Foreground: Glowing Eyes / Dark Particles */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4236" data-mp="9rc6fkwnx2db">
          
            {/* Particles */}
            <circle cx="40" cy="60" r="3" fill="#A78BFA" opacity="0.8" data-id="element-4237" data-mp="jrml79ycihul" />
            <circle cx="160" cy="80" r="2" fill="#8B5CF6" opacity="0.6" data-id="element-4238" data-mp="3s5lfm75o5v5z" />
            <circle cx="140" cy="150" r="4" fill="#C4B5FD" opacity="0.5" data-id="element-4239" data-mp="3n71rq17im9az" />
            <circle cx="60" cy="140" r="2.5" fill="#7C3AED" opacity="0.7" data-id="element-4240" data-mp="3n8uyrhm1ivji" />

            {/* Vignette border */}
            <rect x="0" y="0" width="200" height="200" fill="url(#vignette)" data-id="element-4241" data-mp="5sd4m9689lq3" />
            <defs data-id="element-4242" data-mp="yin9ce3hiu6">
              <radialGradient id="vignette" cx="50%" cy="50%" r="50%" fx="50%" fy="50%" data-id="element-4243" data-mp="xz5bvog2ug5">
              
                <stop offset="70%" stopColor="black" stopOpacity="0" data-id="element-4244" data-mp="39dajcw5isvgu" />
                <stop offset="100%" stopColor="black" stopOpacity="0.6" data-id="element-4245" data-mp="34ga9sb9gpakz" />
              </radialGradient>
            </defs>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}